import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'pace-forms-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent {
    @Input()
    public disabled = false;

    @Input()
    public insideClick = false;

    @Input()
    public dropDownButtonText: string;

    public defaultDropDownButtonText: string;
    public constructor(private readonly translate: TranslateService) {
        this.defaultDropDownButtonText = this.translate.instant('F4M_CONTENT_RENDER_SELECT_ANSWER_LABEL');
    }
}
